import { render, staticRenderFns } from "./mod15.vue?vue&type=template&id=3ad83bf4&scoped=true&"
import script from "./mod15.vue?vue&type=script&lang=js&"
export * from "./mod15.vue?vue&type=script&lang=js&"
import style0 from "./mod15.vue?vue&type=style&index=0&id=3ad83bf4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ad83bf4",
  null
  
)

export default component.exports